// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var FeedbackContents = function (x) {
    return x;
};
var tsBridgeFeedbackContents = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("FeedbackContents")("__brandFeedbackContents"));
    }
};
var writeFeedbackContents = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showFeedbackContents = Data_Show.showString;
var readFeedbackContents = Simple_JSON.readString;
var ordFeedbackContents = Data_Ord.ordString;
var newtypeFeedbackContents = {
    Coercible0: function () {
        return undefined;
    }
};
var makeFeedbackContents = FeedbackContents;
var eqFeedbackContents = Data_Eq.eqString;
export {
    FeedbackContents,
    makeFeedbackContents,
    unwrap,
    newtypeFeedbackContents,
    eqFeedbackContents,
    ordFeedbackContents,
    showFeedbackContents,
    readFeedbackContents,
    writeFeedbackContents,
    tsBridgeFeedbackContents
};
//# sourceMappingURL=index.js.map
